export default () => {
  $(function() {
    var heightheaderChange = true;
    const headerParent = $(".header-container").closest(".row");
    const headerParentHeightIni = headerParent.height();
    headerParent.css("min-height", headerParentHeightIni);

    stickyHeader();

    $(window).scroll(function () {
        if (heightheaderChange) {
            let headerParentHeightScroll = headerParent.height();
            if (headerParentHeightScroll > headerParentHeightIni) {
                $(".header-container").closest(".row").css("min-height", headerParentHeightScroll);
                heightheaderChange = null;
            }
        }
      stickyHeader();
    });
  });

  function stickyHeader() {
    const scroll = $(window).scrollTop();
    const headerContainer = $(".header-container");
    const headerHeight = headerContainer.closest(".row").height();
    if (scroll > headerHeight) {
      headerContainer.addClass("sticky");
    } else if (scroll < headerHeight) {
      headerContainer.removeClass("sticky");
    }
  }
}
